var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',{attrs:{"id":"viewTemplateModal","size":"lg","modalBodyClass":"p-2","toggle":true}},[_c('div',{staticStyle:{"height":"100%"}},[_c('iframe',{ref:"iframe",staticClass:"template-frame",attrs:{"title":"static mail template","srcdoc":_vm.templateHtml,"width":"100%"},on:{"load":_vm.getHeight}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }